// File: src/components/Logo.js
import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.gap || '8px'};
`;

const LogoImg = styled.img`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  object-fit: contain;
`;

const LogoText = styled.div`
  font-size: ${props => props.textSize || '18px'};
  font-weight: 600;
  color: ${props => props.color || '#333'};
  text-align: left;
  line-height: 1.2;
`;

const Logo = ({ size = '40px', textSize = '18px', color = '#333', showText = true, gap = '8px' }) => {
  return (
    <LogoContainer gap={gap}>
      <LogoImg 
        src="/logo192.png"
        alt="ShowingBooker Logo"
        size={size}
      />
      {showText && (
        <LogoText textSize={textSize} color={color}>
          ShowingBooker
        </LogoText>
      )}
    </LogoContainer>
  );
};

export default Logo;